import type { ReactElement, ReactNode } from 'react';
import classnames from 'classnames';
import { cloneElement } from 'react';
import CustomModal from 'react-bootstrap/Modal';

interface IModalProps {
    actionButtons?: ReactElement<{ key: number }>[];
    bgColor?: 'warning';
    children: ReactNode;
    closeButton?: boolean;
    handleClose: () => void;
    isOpen: boolean;
    size: 'xsmall' | 'small' | 'medium' | 'large' | 'fullscreen';
    staticBackdrop?: boolean | 'static';
    title: string;
}
export function Modal(props: IModalProps) {
    const className = classnames({
        'modal-fullscreen': props.size === 'fullscreen',
        'modal-large': props.size === 'large',
        'modal-medium': props.size === 'medium',
        'modal-small': props.size === 'small',
        'modal-warning': props.bgColor === 'warning',
        'modal-xsmall': props.size === 'xsmall',
    });

    return (
        <CustomModal
            backdrop={props.staticBackdrop ? 'static' : undefined}
            dialogClassName={className}
            onHide={props.handleClose}
            show={props.isOpen}
        >
            <CustomModal.Header
                closeButton={props.closeButton}
                onPointerEnterCapture={() => {}}
                onPointerLeaveCapture={() => {}}
                placeholder={''}
            >
                <CustomModal.Title>{props.title}</CustomModal.Title>
            </CustomModal.Header>
            <CustomModal.Body>{props.children}</CustomModal.Body>
            <CustomModal.Footer>
                {props.actionButtons &&
                    props.actionButtons.map((button) => cloneElement(button, { key: button.props.key }))}
            </CustomModal.Footer>
        </CustomModal>
    );
}
